/* eslint-disable i18next/no-literal-string -- Web Crypto requires this exact algorithm identifier. */
const SHA_1_ALGORITHM = 'SHA-1'
/* eslint-enable i18next/no-literal-string */

async function toSHA1(message: string) {
  const msgUint8 = new TextEncoder().encode(message) // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest(SHA_1_ALGORITHM, msgUint8) // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)) // convert buffer to byte array
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('') // convert bytes to hex string
  return hashHex
}

export default toSHA1
